import { ICounter } from "config/types";
import { setTimer } from "store/actions/counter";

import { createReducer } from "@reduxjs/toolkit";

const defaultState = {
  timer: {} as Record<string, number>,
} satisfies ICounter;

const counter = createReducer(defaultState, builder => {
  builder.addCase(setTimer, (state, action) => {
    const { name, value } = action.payload;
    if (value !== undefined) {
      state.timer[name] = value;
    } else {
      delete state.timer[name];
    }
  });
});
export default counter;
